import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const CompanyContext = createContext({ name: "SPBU Energy ERP", tagline: "", spbu_code: "" });

export const CompanyProvider = ({ children }) => {
  const { user } = useAuth();
  const [company, setCompany] = useState({ name: "SPBU Energy ERP", tagline: "Financial & Stock Management", spbu_code: "34.12304" });

  useEffect(() => {
    if (!user) return;
    api.get("/settings/company").then((r) => setCompany(r.data)).catch(() => {});
  }, [user]);

  return <CompanyContext.Provider value={{ company, refresh: () => api.get("/settings/company").then((r) => setCompany(r.data)) }}>{children}</CompanyContext.Provider>;
};

export const useCompany = () => useContext(CompanyContext);
